import { RootState } from '@/store';
import { PICTURES_SLICE_NAME, PictureState } from './models';

export const picturesSelector = (state: RootState): PictureState => state[PICTURES_SLICE_NAME];
